var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-card",
        [
          _c(
            "el-row",
            { staticClass: "row-item", attrs: { gutter: 16 } },
            [
              _c("el-col", { attrs: { span: 6 } }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("storage::in-stock::instock_type")) +
                    "： "
                ),
                _c("span", [_vm._v(_vm._s(_vm.order.stockTypeName))]),
              ]),
              _c("el-col", { attrs: { span: 6 } }, [
                _vm._v(
                  " " + _vm._s(_vm.$t("storage::in-stock::supplier")) + "： "
                ),
                _c("span", [_vm._v(_vm._s(_vm.order.supplierName))]),
              ]),
              _c("el-col", { attrs: { span: 6 } }, [
                _vm._v(
                  " " + _vm._s(_vm.$t("storage::in-stock::relate_num")) + "： "
                ),
                _c("span", [_vm._v(_vm._s(_vm.order.sourceNo))]),
              ]),
              _c("el-col", { attrs: { span: 6 } }, [
                _vm._v(
                  " " + _vm._s(_vm.$t("storage::in-stock::remark")) + "： "
                ),
                _c("span", [_vm._v(_vm._s(_vm.order.remark))]),
              ]),
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "row-item", attrs: { gutter: 16 } },
            [
              _c("el-col", { attrs: { span: 6 } }, [
                _vm._v(
                  " " + _vm._s(_vm.$t("storage::in-stock::creator")) + "： "
                ),
                _c("span", [_vm._v(_vm._s(_vm.order.applicantditorName))]),
              ]),
              _c("el-col", { attrs: { span: 6 } }, [
                _vm._v(
                  " " + _vm._s(_vm.$t("storage::in-stock::create_time")) + "： "
                ),
                _c("span", [_vm._v(_vm._s(_vm.order.createTime))]),
              ]),
              _c("el-col", { attrs: { span: 6 } }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("storage::in-stock::fullfillment_num")) +
                    "： "
                ),
                _c("span", [_vm._v(_vm._s(_vm.order.fulfillmentNo))]),
              ]),
              _c("el-col", { attrs: { span: 6 } }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("storage::in-stock::add_stock_no")) +
                    "： "
                ),
                _c("span", [_vm._v(_vm._s(_vm.order.stockNo))]),
              ]),
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "row-item", attrs: { gutter: 16 } },
            [
              _c("el-col", { attrs: { span: 6 } }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("storage::in-stock::table_auditor")) +
                    "： "
                ),
                _c("span", [_vm._v(_vm._s(_vm.order.auditorName))]),
              ]),
              _c("el-col", { attrs: { span: 6 } }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("storage::in-stock::table_audit_time")) +
                    "： "
                ),
                _c("span", [_vm._v(_vm._s(_vm.order.auditTime))]),
              ]),
              _c("el-col", { attrs: { span: 6 } }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("storage::in-stock::third_bill_num")) +
                    "： "
                ),
                _c("span", [_vm._v(_vm._s(_vm.order.thirdPartyNo))]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-card",
        { staticStyle: { "margin-top": "10px" } },
        [
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "justify-content": "space-between",
                "margin-bottom": "16px",
              },
            },
            [
              _c("div"),
              _c(
                "div",
                [
                  _c("span", [_vm._v("SKU")]),
                  _c(
                    "el-input",
                    {
                      staticStyle: { width: "200px", "margin-left": "5px" },
                      model: {
                        value: _vm.searchValue,
                        callback: function ($$v) {
                          _vm.searchValue = $$v
                        },
                        expression: "searchValue",
                      },
                    },
                    [
                      _c("el-button", {
                        attrs: { slot: "append", icon: "el-icon-search" },
                        slot: "append",
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
          _c("z-table", {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            staticClass: "prodinfo--table",
            attrs: {
              columns: _vm.tableColumns,
              data: _vm.searchList,
              "max-height": 600,
              pagination: false,
            },
            scopedSlots: _vm._u([
              {
                key: "skuId",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(row.skuId) +
                          _vm._s(row.skuProperty ? "-" + row.skuProperty : "")
                      ),
                    ]),
                  ]
                },
              },
              {
                key: "spuName",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c(
                      "div",
                      { staticClass: "prodinfo--table__imgTd" },
                      [
                        _c(
                          "el-popover",
                          {
                            attrs: { placement: "top-start", trigger: "hover" },
                          },
                          [
                            _c("ZImg", {
                              staticStyle: { width: "250px", height: "250px" },
                              attrs: { src: row.img },
                            }),
                            _c("ZImg", {
                              staticStyle: {
                                width: "50px",
                                height: "50px",
                                "margin-right": "10px",
                              },
                              attrs: { slot: "reference", src: row.img },
                              slot: "reference",
                            }),
                          ],
                          1
                        ),
                        _c("div", [
                          _c("div", [_vm._v(_vm._s(row.title))]),
                          _c("div", [_vm._v(_vm._s(row.categoryName))]),
                        ]),
                      ],
                      1
                    ),
                  ]
                },
              },
              {
                key: "qty",
                fn: function (ref) {
                  var row = ref.row
                  return [_vm._v(" " + _vm._s(_vm.$dataCheck(row.qty)) + " ")]
                },
              },
              {
                key: "totalPrice",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _vm._v(" " + _vm._s(_vm.$dataCheck(row.totalPrice)) + " "),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }